/** Consumer product tier stored on `users/{uid}.productTier` (register default: free). */
export type ProductTierValue = 'free' | string;

/** Routing audience for tier-aware surfaces (no paid entitlement logic in #1706). */
export type ProductTierAudience = 'anonymous' | 'free' | 'workbench';

/**
 * Resolves which calculator/shell experience to show.
 * Missing or unknown tiers for signed-in users default to free.
 */
export function resolveProductTierAudience(
  hasUser: boolean,
  productTier: string | null | undefined,
): ProductTierAudience {
  if (!hasUser) return 'anonymous';

  const trimmed = productTier?.trim();
  if (!trimmed || trimmed.toLowerCase() === 'free') return 'free';

  /** Placeholder for future paid/pro/governed tiers — workbench only when explicitly non-free. */
  return 'workbench';
}

/** Normalises Firestore/profile tier for display and persistence checks. */
export function normalizeProductTier(productTier: string | null | undefined): ProductTierValue {
  if (productTier == null || productTier.trim() === '') return 'free';
  return productTier.trim();
}
